import type {ProductState, ProductStateShare, ViewProduct} from '../../i';

type SizingProduct = Pick<ViewProduct, 'ProductTypeID' | 'FixedSizeDisplay' | 'IsCAF'>;
type CatalogSizing = SizingProduct & Pick<ViewProduct, 'docWidth' | 'docHeight' | 'docWidth2' | 'docHeight2' | 'IsHorizontal' | 'orig_pcs'>;
type SizingState = Pick<ProductState, 'docWidth' | 'docHeight' | 'docWidth2' | 'docHeight2' | 'is_horizontal' | 'DocSizeID' | 'category_map_id' | 'category_selected_no_new_product'>;

// Type 13 is a stole-only display, including cached products created before the flag existed.
export const isFixedSizeDisplay = (product: SizingProduct): boolean => !product.IsCAF && (product.FixedSizeDisplay === true || product.ProductTypeID === 13);

// Keep aligned with Redis_Products_Select and the server's document-size policy.
const noAutomatedSizes = new Set([13, 30, 92, 69, 79, 85, 86, 10, 50, 56, 57, 58, 59, 60, 16, 24, 31, 32, 49, 54, 74, 76, 77, 78]);

export const allowsAutomatedDocSizes = (product: SizingProduct, storeEnabled: boolean): boolean => storeEnabled && !isFixedSizeDisplay(product) && !noAutomatedSizes.has(product.ProductTypeID);

export const restoreFixedDisplaySizing = (product: CatalogSizing, state: SizingState): void => {
    if (!isFixedSizeDisplay(product)) return;
    state.docWidth = product.docWidth;
    state.docHeight = product.docHeight;
    state.docWidth2 = product.docWidth2;
    state.docHeight2 = product.docHeight2;
    state.is_horizontal = product.IsHorizontal;
    state.DocSizeID = 0;
    state.category_map_id = product.orig_pcs.SelectedCategoryMapID;
    state.category_selected_no_new_product = false;
};

export const applySharedDocumentSizing = (product: CatalogSizing, state: SizingState, shared: Pick<ProductStateShare, 'o' | 'w1' | 'w2' | 'h1' | 'h2'>): void => {
    state.is_horizontal = shared.o;
    state.docWidth = shared.w1;
    state.docWidth2 = shared.w2;
    state.docHeight = shared.h1;
    state.docHeight2 = shared.h2;
    restoreFixedDisplaySizing(product, state);
};

export const allowsCategoryOption = (product: SizingProduct, option: {LinkToProductID: number}): boolean => !isFixedSizeDisplay(product) || option.LinkToProductID > 0;
